/* eslint-disable no-underscore-dangle */
import React from 'react'
import { LandingPageDescription } from './LandingPageDescription'

export const LandingPageDynamicZone = ({
  landingPageDynamicZones,
}: {
  landingPageDynamicZones: Queries.AllPagesQuery['allStrapiLandingPage']['nodes'][0]['landingPageDynamicZone']
}) => {
  if (!landingPageDynamicZones || landingPageDynamicZones.length === 0) {
    return null
  }

  return landingPageDynamicZones.map((landingPageDynamicZone) => {
    switch (landingPageDynamicZone?.__typename) {
      case 'STRAPI__COMPONENT_LANDING_TOWN_PRESENTATION':
        return <LandingPageDescription
          description={landingPageDynamicZone?.description}
          mainMedia={landingPageDynamicZone?.mainMedia}
          title={landingPageDynamicZone?.title}
        />
      default:
        return null
    }
  })
}
